module.exports = __webpack_public_path__ + "img/bosspack.d49db269.png";